import http from '../../services/http/index';
import forResponse from '../../utils/forResponse';
import { FANCLUB_PURCHASE_INFO_URL, GET_PRODUCT_PURCHASE_INFO } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';
import { getCookie } from '../../utils/helpers';


export const getFanclubPurchaseInfo = (anchorId, username) => {
  const url = FANCLUB_PURCHASE_INFO_URL.
    replace('{anchorId}', encodeURIComponent(anchorId)).
    replace('{username}', encodeURIComponent(username));

  return forResponse(http.get(url));
};

export const getPurchaseInfo = (packageId, anchorId, trackingData, additionalInfo, userName, crossSellOff) => {
  const url = GET_PRODUCT_PURCHASE_INFO.replace('{id}', packageId);
  const { passThrough } = trackingData || {};
  const payload = {};
  if (additionalInfo) {
    payload.additionalInfo = additionalInfo;
  }
  if (passThrough?.affiliateCode?.length) {
    payload.affiliateCode = passThrough.affiliateCode;
  }
  const atcParameter = getCookie('affiliateCode') || getCookie('_atc');
  if (atcParameter) {
    payload.affiliateCode = atcParameter;
  }

  if (passThrough?.hash?.length) {
    payload.campaignHash = passThrough.hash;
  }

  if (userName) {
    payload.userName = userName;
  }

  payload.crossSellOff = crossSellOff;

  return callApi(url, 'post', { anchorId }, payload, {}, true, true);
};
